<template>
  <div style="padding-bottom: 15px">
    <!-- <van-notice-bar :text="list.text" left-icon="volume-o" mode="closeable" /> -->

    <div style="background-color: #fff; margin-top: 15px">
      <van-cell value="更多" is-link to="/notice">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="custom-title">通知</span>
        </template>
      </van-cell>
      <!-- <div class="notice" v-for="item in statistics.notice_list" :key="item.notice_id">
				<van-cell :title="item.notice_content" :value="handleDate(Date.parse(item.create_date))" />
			</div>-->
      <van-notice-bar v-for="item in statistics.notice_list" :key="item.notice_id" :text="item.notice_content"
        left-icon="volume-o" mode="closeable" />
    </div>

    <van-cell-group style="margin-top: 15px" v-if="statistics.sales_statistics && statistics.salesStatisticsYear">
      <van-row>
        <van-col span="8">
          <van-cell title="销售业绩" :label="'¥' + statistics.sales_statistics.sales ">
            <template #right-icon>
              <van-tag type="success" style="height: 1.7em">月</van-tag>
            </template>
          </van-cell>
        </van-col>
        <van-col span="8">
          <van-cell title="成交订单" :label="statistics.sales_statistics.total || 0 ">
            <template #right-icon>
              <van-tag type="success" style="height: 1.7em">月</van-tag>
            </template>
          </van-cell>
        </van-col>
        <van-col span="8">
          <van-cell title="销售业绩" :label="'¥' + (statistics.salesStatisticsYear.sales || 0)">
            <template #right-icon>
              <van-tag type="primary" style="height: 1.7em">年</van-tag>
            </template>
          </van-cell>
        </van-col>
      </van-row>
      <van-row>
        <van-col span="8">
          <van-cell title="客户新增" :label="statistics.client_statistics || 0">
            <template #right-icon>
              <van-tag type="primary" style="height: 1.7em">日</van-tag>
            </template>
          </van-cell>
        </van-col>
        <van-col span="8">
          <van-cell title="总质保金" :label="'¥' + (statistics.credit_statistics.reten_account || 0)">
            <template #right-icon>
              <van-tag type="warning" style="height: 1.7em">总</van-tag>
            </template>
          </van-cell>
        </van-col>
        <van-col span="8">
          <van-cell title="总应收款" :label="'¥'+(statistics.credit_statistics.owe_amount || 0)">
            <template #right-icon>
              <van-tag type="warning" style="height: 1.7em">总</van-tag>
            </template>
          </van-cell>
        </van-col>
      </van-row>
    </van-cell-group>
    <!-- 代办通知 -->
    <van-cell style="margin-top: 15px" id="targetBox">
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{ listTitle[form.type] }}</span>
      </template>
    </van-cell>
    <van-list v-model="list.loading" :finished="list.finished" finished-text @load="onLoad"
      style="padding-bottom: 15px">
      <div v-if="form.type == 0">
        <van-cell v-for="item in list.list" :key="item.link" :title="item.title"
          :value="handleDate(Date.parse(item.date))" @click="linkTo(item.process_type, item.link)"
          style="color: #ee0a24; background-color: #fffbe8" />
      </div>
      <div v-else>
        <van-cell v-for="item in list.list" :key="item.link" :title="item.contact_person"
          :value="client_status[item.client_status]" @click="linkTo(item.process_type, item.link)"
          style="color: #ee0a24; background-color: #fffbe8" />
      </div>
      <!-- 添加无数据时的提示 -->
      <div v-if="list.list.length === 0 && list.finished" style="text-align: center; padding: 20px; color: #969799;">
        暂无通知
      </div>
    </van-list>

    <!-- <div id="targetBox"></div> -->
  </div>
</template>

<script>
import { Toast } from "vant";
import { post } from "@/api/post";
import "@/utils/format.js";

export default {
  name: "list",
  data() {
    return {
      statistics: {
        sales_statistics:{sales: 0,total: 0},
        salesStatisticsYear:{sales:0,total: 0},
        client_statistics: 0,
        credit_statistics:{reten_account:0,owe_amount: 0},
      },
      list: {
        list: [],
        loading: false,
        finished: false,
      },
      listTitle: ["待办通知", "近七天待跟进客户"],
      // listTitle: ["待办通知"],
      form: {
        requestType: "home_upcoming_list",
        page: 1,
        limit: 10,
        type: 0,
      },
      client_status: [
        "意向客户",
        "现场确认尺寸和方案",
        "已做报价及方案",
        "需要配合招投标",
        "待签订合同",
        "已签订合同",
        "跟单失败客户",
      ],
      ws: "",
      upcomingList: [
        "/order/details",
        "/dispatch/details_distribution",
        "/purchase/details",
      ],
      isLoading: false,
    };
  },
  props: {
    vModel: {
      type: Object,
      default: function () {
        return {};
      },
    },
    refresh: Boolean,
  },
  mounted() {},
  methods: {
    getElementTop(element) {
      var actualTop = element.offsetTop;
      var current = element.offsetParent;

      while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
      }

      console.log(actualTop);
      return actualTop;
    },
    onLoad() {
      post(this.form)
        .then((res) => {
          if (res.obj.rows[0].rows.length === 0) {
            this.list.finished = true;
          }
          if (this.form.page != 1) {
            this.list.list = this.list.list.concat(res.obj.rows[0].rows);
          } else {
            this.form.type = res.obj.rows[0].type;
            this.list.list = res.obj.rows[0].rows;
          }

          setTimeout(() => {
            if (this.form.page == 2 && res.obj.rows[0].type == 1) {
              let top = Number(
                this.getElementTop(document.getElementById("targetBox")) - 15
              );
              document.documentElement.scrollTop = top;
              document.body.scrollTop = top;
            }
          }, 200);

          this.form.page += 1;
          this.list.loading = false;

          if (this.isLoading == true) {
            this.isLoading = false;
            this.$emit("reSuccess", false);
          }
        })
        .catch((err) => {
          console.log(err);
          this.list.loading = false;
          this.list.finished = true;
          return Toast.fail("请重新登陆!");
        });
    },
    linkTo(type, id) {
      console.log(type);
      let path = "/review/details";
      if (this.form.type == 1) {
        path = "/customer/follow";
      }else if(type == 3){
        path = "/returnManagement/details";
      }else {
        if (type >= 10) {
          //   path = this.upcomingList[Number(type - 10)];
          path = this.upcomingList[2];
        } else if (type >= 8) {
          path = this.upcomingList[Number(type - 8)];
        }
      }

      this.$router.push({
        path: path,
        query: { type: type, id: id, p: true },
      });
    },
    handleDate(dateTimeStamp) {
      let minute = 1000 * 60;
      let hour = minute * 60;
      let day = hour * 24;
      let result = "";
      let now = new Date().getTime();
      let diffValue = now - dateTimeStamp;
      if (diffValue < 0) {
        return (result = "刚刚");
      }
      let dayC = diffValue / day;
      let hourC = diffValue / hour;
      let minC = diffValue / minute;
      if (parseInt(dayC) > 30) {
        result = "" + new Date(dateTimeStamp).format("Y-m-d");
      } else if (parseInt(dayC) > 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (parseInt(dayC) == 1) {
        result = "昨天";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 5) {
        result = "" + parseInt(minC) + "分钟前";
      } else result = "刚刚";
      return result;
    },
  },
  watch: {
    vModel: {
      immediate: true,
      handler(newV) {
        this.statistics = newV;
      },
    },
    refresh: {
      immediate: true,
      handler(newV) {
        this.isLoading = newV;
        if (this.isLoading == true) {
          this.form.page = 1;
          this.onLoad();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell__label {
  color: #1989fa;
}

.notice {
  .van-cell {
    justify-content: space-between;
  }

  .van-cell__title {
    flex: initial;
    width: 100%;
  }
  .van-cell__value {
    flex: initial;
    flex-shrink: 0;
  }
}

.van-cell__value {
  span {
    font-size: 12px;
  }
}
</style>